import { MdConfirmationNumber } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupPredictionVoucherRule;

export const list = MainPage;

export const icon = MdConfirmationNumber;

export const options = { label: 'resource.worldCupPredictionVoucherRule' };
